var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.5C8.63664 8.5 9.72673 8.05223 10.5305 7.2552C11.3342 6.45817 11.7857 5.37717 11.7857 4.25C11.7857 3.12283 11.3342 2.04183 10.5305 1.2448C9.72673 0.447767 8.63664 0 7.5 0C6.36336 0 5.27327 0.447767 4.46954 1.2448C3.66581 2.04183 3.21429 3.12283 3.21429 4.25C3.21429 5.37717 3.66581 6.45817 4.46954 7.2552C5.27327 8.05223 6.36336 8.5 7.5 8.5ZM5.96987 10.0938C2.67188 10.0938 0 12.7434 0 16.0139C0 16.5584 0.445313 17 0.99442 17H14.0056C14.5547 17 15 16.5584 15 16.0139C15 12.7434 12.3281 10.0938 9.03013 10.0938H5.96987Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5d97ced764f061719b77969ecd26d909.svg";
export { ForwardRef as ReactComponent };